module.exports = __webpack_public_path__ + "img/calligraphy_maobi.403e5352.png";